/** Sedes de la empresa (T071 · US3). */
import { createFileRoute } from '@tanstack/react-router';

import { SitesPage } from '../../features/sites/sites-page';

export const Route = createFileRoute('/_app/sedes')({
  component: SitesPage,
});
